
import { defineComponent, PropType } from 'vue';

type OfferLike = {
  id: number;
  status?: string;
  [key: string]: unknown;
};

export default defineComponent({
  emits: ['approve', 'decline', 'reset'],
  props: {
    offer: {
      type: Object as PropType<OfferLike>,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    imageSrc(): string {
      const artwork = this.offer['artwork'];
      const artworkObj =
        artwork && typeof artwork === 'object'
          ? (artwork as Record<string, unknown>)
          : null;
      const image = artworkObj?.['image'];
      const imageObj =
        image && typeof image === 'object'
          ? (image as Record<string, unknown>)
          : null;
      const src = imageObj?.['medium'];
      const srcStr = typeof src === 'string' ? src : '';
      if (srcStr && srcStr.trim().length) return srcStr;
      return require('@/assets/imgs/avatar.png');
    },

    artistName(): string {
      const artwork = this.offer['artwork'];
      const artworkObj =
        artwork && typeof artwork === 'object'
          ? (artwork as Record<string, unknown>)
          : null;
      const artist = artworkObj?.['artist'];
      const artistObj =
        artist && typeof artist === 'object'
          ? (artist as Record<string, unknown>)
          : null;
      const fullName = artistObj?.['full_name'];
      if (typeof fullName === 'string') return fullName;

      const artistName = artworkObj?.['artist_name'];
      if (typeof artistName === 'string') return artistName;

      return '';
    },

    artworkTitle(): string {
      const artwork = this.offer['artwork'];
      const artworkObj =
        artwork && typeof artwork === 'object'
          ? (artwork as Record<string, unknown>)
          : null;

      const title = artworkObj?.['title'];
      if (typeof title === 'string') return title;

      const fallback = this.offer['artwork_title'];
      if (typeof fallback === 'string') return fallback;

      return '';
    },

    priceText(): string {
      const price =
        this.offer['price'] ??
        this.offer['offer_price'] ??
        this.offer['amount'];
      if (price === undefined || price === null || price === '') return '';
      return `$${String(price)}`;
    },

    statusParsed(): string {
      const status = String(this.offer?.status ?? '');
      if (status === 'pending') return 'Pending';
      if (status === 'accepted') return 'Accepted';
      if (status === 'declined') return 'Declined';
      return status;
    },

    isPending(): boolean {
      return String(this.offer?.status) === 'pending';
    },
  },
});
